import { render } from "./TxMap2.vue?vue&type=template&id=23158dc1&scoped=true"
import script from "./TxMap2.vue?vue&type=script&lang=js"
export * from "./TxMap2.vue?vue&type=script&lang=js"

import "./TxMap2.vue?vue&type=style&index=0&id=23158dc1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23158dc1"]])

export default __exports__